<template>
  <!-- Begin Widget.event-detail -->
  <div v-if="responseError" class="angebot-detail error">
    <p-request-alert v-model="responseError"></p-request-alert>
  </div>
  <div v-else-if="isLoading" class="angebot-detail loading">
    <p-progress-linear indeterminate></p-progress-linear>
  </div>
  <div v-else class="angebot-detail">
    <a class="backlink" href="javascript:history.back();">&lt; {{ $t('widget.events.backToAppointmentOverview') }}</a>
    <div class="row">
      <div class="col-12 titlewrapper">
        <h1>{{ model.name }}</h1>
        <div class="subtitle">
          <strong>{{ model.subtitle }}</strong>
        </div>
        <div class="status">
          <div :class="'circle '+ model.registrationIndicator+' '+ model.registrationStatus">
&nbsp;
          </div>
          <div class="availability">
            {{ model.availabilityString }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-5">
        <div class="uebersicht">
          <div class="boxtitle">
            {{ $t('widget.events.overview') }}
          </div>
          <div class="row">
            <template v-if="!_.isEmpty(model.duration)">
              <div class="col-12 col-sm-5 col-md-12 col-lg-5 titel duration">
                {{ $t('widget.events.duration') }}
              </div>
              <div class="col-12 col-sm-7 col-md-12 col-lg-7 duration">
                {{ model.duration }}
              </div>
            </template>
            <div class="col-12 col-sm-5 col-md-12 col-lg-5 titel periode">
              {{ $t('widget.events.periode') }}
            </div>
            <div class="col-12 col-sm-7 col-md-12 col-lg-7 periode">
              {{ $format.localDate(model.startDate) }} - {{ $format.localDate(model.endDate) }}
            </div>
            <template v-if="!_.isEmpty(model.dates)">
              <div class="col-12 col-sm-5 col-md-12 col-lg-5 titel data">
                {{ $t('widget.events.data') }}
              </div>
              <div class="col-12 col-sm-7 col-md-12 col-lg-7 data">
                {{ model.dates }}
              </div>
            </template>
            <template v-if="!_.isEmpty(model.times)">
              <div class="col-12 col-sm-5 col-md-12 col-lg-5 titel times">
                {{ $t('widget.events.times') }}
              </div>
              <div class="col-12 col-sm-7 col-md-12 col-lg-7 times">
                {{ model.times }}
              </div>
            </template>
            <template v-if="!_.isEmpty(model.eventTeachingMethod)">
              <div class="col-12 col-sm-5 col-md-12 col-lg-5 titel eventTeachingMethod">
                {{ $t('widget.events.teachingMethod') }}
              </div>
              <div class="col-12 col-sm-7 col-md-12 col-lg-7 eventTeachingMethod">
                {{ model.eventTeachingMethod }}
              </div>
            </template>
          </div>
        </div>
        <div class="infos">
          <div class="boxtitle">
            {{ $t('widget.events.infoAndDocuments') }}
          </div>
          <template v-if="!_.isEmpty(model.place)">
            <div class="row place">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.city') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.place }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.meetingPoint)">
            <div class="row meetingPoint">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.meetingPoint') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.meetingPoint }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.costs)">
            <div class="row costs">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.costs') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.costs }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.teachingMethod)">
            <div class="row teachingMethod">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.teachingMethod') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.teachingMethod }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.certificate)">
            <div class="row certificate">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.certificate') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.certificate }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.registrationDeadline)">
            <div class="row registrationDeadline">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.registrationDeadline') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.registrationDeadline }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.cancellation)">
            <div class="row cancellation">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.cancellation') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.cancellation }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.remarks)">
            <div class="row remarks">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.remarks') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                {{ model.remarks }}
              </div>
            </div>
          </template>
          <template v-if="!_.isEmpty(model.detailUrl)">
            <div class="row detailUrl">
              <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
                {{ $t('widget.events.link') }}
              </div>
              <div class="col-12 col-lg-7 col-md-12 col-sm-7">
                <a
                  class="link"
                  target="_blank"
                  :href="model.detailUrl"
                >{{ model.detailUrl }}</a>
              </div>
            </div>
          </template>
          <div v-if="model.hasDocuments" class="row">
            <div class="col-12 col-lg-5 col-md-12 col-sm-5 titel">
              {{ $t('widget.events.documents') }}
            </div>
            <div class="col-12 col-lg-7 col-md-12 col-sm-7">
              <a
                v-if="!_.isEmpty(model.eventDocumentsUrl)"
                class="filedownload"
                target="_blank"
                :href="model.eventDocumentsUrl"
              >{{ $t('widget.events.courseDocuments') }}</a>
              <a
                v-if="!_.isEmpty(model.locationMapUrl)"
                class="filedownload"
                target="_blank"
                :href="model.locationMapUrl"
              >{{ $t('widget.events.sitePlan') }}</a>
              <a
                v-if="!_.isEmpty(model.eventInformationDocumentUrl)"
                class="filedownload"
                target="_blank"
                :href="model.eventInformationDocumentUrl"
              >{{ $t('widget.events.informationDocuments') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="description pre-line">
          {{ model.description }}
        </div>
        <div v-if="!_.isEmpty(model.eventGoals)" class="section eventGoals">
          <div class="section-title">
            {{ $t('widget.events.goals') }}
          </div>
          <div class="section-text">
            {{ model.eventGoals }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.schedule)" class="section schedule">
          <div class="section-title">
            {{ $t('widget.events.procedure') }}
          </div>
          <div class="section-text">
            {{ model.schedule }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.targetAudience)" class="section targetAudience">
          <div class="section-title">
            {{ $t('widget.events.targetGroup') }}
          </div>
          <div class="section-text">
            {{ model.targetAudience }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.niveaus)" class="section niveaus">
          <div class="section-title">
            {{ $t('widget.events.niveau') }}
          </div>
          <div class="section-text">
            {{ (model.niveaus ? model.niveaus : []).join(', ') }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.teachingMethod)" class="section teachingMethod">
          <div class="section-title">
            {{ $t('widget.events.teachingMethod') }}
          </div>
          <div class="section-text">
            {{ model.teachingMethod }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.previousKnowledge)" class="section previousKnowledge">
          <div class="section-title">
            {{ $t('widget.events.previousKnowledge') }}
          </div>
          <div class="section-text">
            {{ model.previousKnowledge }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.requirements)" class="section requirements">
          <div class="section-title">
            {{ $t('widget.events.requirements') }}
          </div>
          <div class="section-text">
            {{ model.requirements }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.administration)" class="section administration">
          <div class="section-title">
            {{ $t('widget.events.administration') }}
          </div>
          <div class="section-text">
            {{ model.administration }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.leader)" class="section leader">
          <div class="section-title">
            {{ $t('widget.events.courseLead') }}
          </div>
          <div class="section-text">
            {{ model.leader }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.categories)" class="section categories">
          <div class="section-title">
            {{ $t('widget.events.topic') }}
          </div>
          <div class="section-text">
            {{ (model.categories ? model.categories : []).join(', ') }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.contactPerson)" class="section contactPerson">
          <div class="section-title">
            {{ $t('widget.events.contactPerson') }}
          </div>
          <div class="section-text">
            {{ model.contactPerson }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.contactEmail)" class="section contactEmail">
          <div class="section-title">
            {{ $t('widget.events.contactEmail') }}
          </div>
          <div class="section-text">
            {{ model.contactEmail }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.teachingAid)" class="section teachingAid">
          <div class="section-title">
            {{ $t('widget.events.teachingAid') }}
          </div>
          <div class="section-text">
            {{ model.teachingAid }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.documentation)" class="section documentation">
          <div class="section-title">
            {{ $t('widget.events.documentation') }}
          </div>
          <div class="section-text">
            {{ model.documentation }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.preparation)" class="section preparation">
          <div class="section-title">
            {{ $t('widget.events.preparation') }}
          </div>
          <div class="section-text">
            {{ model.preparation }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.workingHours)" class="section workingHours">
          <div class="section-title">
            {{ $t('widget.events.workingHours') }}
          </div>
          <div class="section-text">
            {{ model.workingHours }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.catering)" class="section catering">
          <div class="section-title">
            {{ $t('widget.events.catering') }}
          </div>
          <div class="section-text">
            {{ model.catering }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.travelExpenses)" class="section travelExpenses">
          <div class="section-title">
            {{ $t('widget.events.travelExpenses') }}
          </div>
          <div class="section-text">
            {{ model.travelExpenses }}
          </div>
        </div>
        <div v-if="!_.isEmpty(model.organisation)" class="section organisation">
          <div class="section-title">
            {{ $t('widget.events.organisation') }}
          </div>
          <div class="section-text">
            {{ model.organisation }}
          </div>
        </div>
        <div v-if="model.isOnlineRegistrationActive" class="buttonwrapper">
          <a
            v-if="isRegistrationExternalLink"
            class="button"
            target="_blank"
            :href="registrationLink"
          >{{ $t('widget.events.register') }}</a>
          <a
            v-else
            class="button"
            href="javascript:void(0)"
            @click="gotoRegister"
          >{{ $t('widget.events.register') }}</a>
        </div>
      </div>
    </div>
  </div>
  <!-- End Widget.event-detail -->
</template>

<script lang="ts">
  import Vue from 'vue';
  import ServiceResponse from '../../../../../../src/plugins/servicelayer/responseTypes/serviceResponse';
  import WidgetEventResourceViewModel from '../../services/v1/viewModel/resource/WidgetEventResourceViewModel';

  export default Vue.extend({
    layout: 'layout-widget-no-design',
    data: () => ({
      eventId: undefined as number | undefined,
      model: new WidgetEventResourceViewModel(),
      isLoading: false,
      isAccordeonDetailVisible: [] as boolean[],
      responseError: undefined as any,
      isRegistrationExternalLink: false,
      registrationLink: undefined as string | undefined,
    }),
    computed: {
    },
    async mounted() {
      const pp = this.$routerUtils.getQueryParams();
      const eventid = this.$config.values['widget-eventid'] ?? this.$route.params.eventid ?? pp.eventid;
      if (this._.isSet(eventid)) {
        this.eventId = Number.parseInt(eventid, 10);
        if (!Number.isNaN(this.eventId)) {
          await this.populateData();
        } else {
          this.responseError = `${this.$t('widget.events.invalidEventNumber')}: ${pp.eventid}`;
        }
      } else {
        this.responseError = this.$t('widget.events.noEventNumberSpecified');
        this.$log.error('No eventId given');
      }
      this.registrationLink = this.$service.v1.api.core.widgetEvents.getEventRegisterUrl(this.model);
      this.isRegistrationExternalLink = !!this.$routerUtils.isUrl(this.registrationLink ?? '');
    },
    methods: {
      gotoRegister() {
        this.$routerUtils.pushRouteOrUrl(this.$service.v1.api.core.widgetEvents.getEventRegisterUrl(this.model));
      },
      async populateData() {
        this.isLoading = true;
        try {
          const response = await this.$service.v1.api.core.widgetEvents.getWidgetEventDetail(this.eventId!);
          this.model = response;
        } catch (e) {
          const errorResponse = e as ServiceResponse;
          if (errorResponse.status === 503) {
            // = errorResponse.data;
          }
          this.$log.error(e);
        }
        this.isLoading = false;
      },
      toggleDetail(index:number) {
        this.$set(this.isAccordeonDetailVisible, index, !this.isAccordeonDetailVisible[index]);
      },
    },
  });
</script>
